<script>
  import Symbol from '$lib/Symbol.svelte'

  /**
   * @type {{
   *   size?: 'sm',
   *   id?: string,
   *   value?: string,
   *   placeholder?: string,
   *   options?: {
   *     label?: string,
   *     selected?: boolean,
   *     value?: string,
   *     disabled?: boolean
   *   }[],
   *   label?: Svelte.Snippet|string,
   *   children?: Svelte.Snippet,
   *   [attribute: string]: any
   * }}
   */
  let {
    size,
    placeholder,
    options = [],
    value = $bindable(''),
    id = `select-${Math.random().toString(32).substring(2)}`,
    label,
    children,
    ...attrs
  } = $props()
</script>

<label class="select" class:sm={size === 'sm'} for={id}>
  {#if label}
    <span class="label">
      {#if typeof label === 'function'}
        {@render label()}
      {:else}
        {label}
      {/if}
    </span>
  {/if}
  <span class="container">
    <select bind:value {id} {...attrs} class="field {attrs.class || ''}">
      {#if placeholder}
        <option disabled selected value="">
          {placeholder}
        </option>
      {/if}
      {#each options as option (option.value)}
        {@const selected =
          'selected' in option ? option.selected : option.value === value}
        <option value={option.value} {selected} disabled={option.disabled}>
          {option.label || option.value}
        </option>
      {:else}
        {@render children?.()}
      {/each}
    </select>
    <span class="chevron"><Symbol name="chevron" /></span>
  </span>
</label>

<style>
  .select {
    display: block;
    width: 100%;
    position: relative;
  }

  .label {
    display: inline-block;
    font-weight: 550;
    line-height: 1.2;
    font-size: 1rem;
  }

  .select.sm .label {
    font-size: 0.875rem;
  }

  .container {
    display: flex;
    align-items: center;
    flex: 1 1 100%;
    position: relative;
  }

  .field:disabled,
  .field:invalid {
    color: rgb(var(--rgb-muted));
  }

  .label:not(.is-hidden) + .container .field {
    margin-top: 0.35rem;
  }

  .field {
    display: block;
    flex: 1 1 auto;
    width: 100%;
    height: auto;
    padding: 0.7rem 1.2rem 0.7rem 1rem;
    border: 1px solid rgba(var(--rgb-gray), 0.25);
    border-radius: var(--border-radius-md);
    background: var(--background);
    color: rgb(var(--rgb-text));
    font-size: 1rem;
    text-overflow: ellipsis;
    appearance: none;
    user-select: none;
    box-shadow: var(--box-shadow-sm);
    transition: var(--box-shadow-transition);
    resize: none;
  }

  .select.sm .field {
    height: auto;
    padding: 0.25rem 1.25rem 0.25rem 0.75rem;
  }

  .field:not(:disabled):hover {
    box-shadow: var(--box-shadow-sm-hover);
  }

  .field:focus {
    border-color: rgba(var(--rgb-muted), 0.5);
    box-shadow: var(--box-shadow-sm-hover);
  }

  .field:active {
    box-shadow: var(--box-shadow-sm-active);
  }

  .chevron {
    color: rgb(var(--rgb-muted));
    position: absolute;
    right: 0.5rem;
    top: 50%;
    transform: translateY(-45%);
    pointer-events: none;
  }

  .select.sm .chevron {
    right: 0.25rem;
    transform: translateY(-45%);
  }
</style>
